module.exports = __webpack_public_path__ + "static/img/eicad_img1.04e7c369.png";